import React, { useEffect } from "react";
import keycloak from "../keycloak";

export default function LogoutPage() {
    useEffect(() => {
        const performLogout = async () => {
            try {
                await keycloak.init({
                    onLoad: "check-sso",
                    checkLoginIframe: false,
                    pkceMethod: "S256",
                });
                keycloak.logout({ redirectUri: "http://landing.localhost:3000/" });
            } catch (error) {
                console.error("Error al inicializar Keycloak en LogoutPage:", error);
            }
        };

        performLogout();
    }, []);

    return (
        <div>
            <p>Cerrando sesión...</p>
        </div>
    );
}
